
import { jsPDF } from "jspdf";
import { Document, Packer, Paragraph, TextRun } from "docx";

/**
 * Downloads text content as a PDF file.
 * @param {string} content - The text content to put in the PDF.
 * @param {string} filename - The name of the downloaded file.
 */
export const downloadAsPdf = (content, filename = 'semesta-laundry-result.pdf') => {
    try {
        const doc = new jsPDF();

        // Setup font
        doc.setFont("helvetica", "normal");
        doc.setFontSize(12);

        // Header
        doc.setFontSize(16);
        doc.setFont("helvetica", "bold");
        doc.text("Semesta Laundry - Hasil Analisis", 15, 15);

        // Reset for body
        doc.setFontSize(11);
        doc.setFont("helvetica", "normal");

        // Split text to fit page width (A4 width ~210mm, margins 15mm => max 180mm)
        const splitText = doc.splitTextToSize(content, 180);

        let y = 25;
        // Check for page break if text is too long
        const pageHeight = doc.internal.pageSize.height;

        // Simple loop to add text
        splitText.forEach(line => {
            if (y > pageHeight - 15) {
                doc.addPage();
                y = 15;
            }
            doc.text(line, 15, y);
            y += 6; // Line height
        });

        // Save
        const finalName = filename.toLowerCase().endsWith('.pdf') ? filename : `${filename}.pdf`;
        doc.save(finalName);
    } catch (error) {
        console.error("PDF Generation Error:", error);
        alert("Gagal membuat PDF: " + error.message);
    }
};

/**
 * Downloads text content as a DOCX file.
 * @param {string} content - The text content to put in the DOCX.
 * @param {string} filename - The name of the downloaded file.
 */
export const downloadAsDocx = async (content, filename = 'semesta-laundry-result.docx') => {
    try {
        // Split text by newlines to create paragraphs
        const lines = content.split('\n');

        const docParagraphs = lines.map(line =>
            new Paragraph({
                children: [
                    new TextRun({
                        text: line,
                        font: "Calibri",
                        size: 24, // 12pt (docx uses half-points)
                    })
                ],
                spacing: { after: 120 }, // Spacing after paragraph
            })
        );

        // Add Header
        const headerParagraph = new Paragraph({
            children: [
                new TextRun({
                    text: "Semesta Laundry - Hasil Analisis",
                    bold: true,
                    size: 32, // 16pt
                    font: "Calibri"
                })
            ],
            spacing: { after: 400 }
        });

        const doc = new Document({
            sections: [{
                properties: {},
                children: [headerParagraph, ...docParagraphs]
            }]
        });

        const blob = await Packer.toBlob(doc);
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        const finalName = filename.toLowerCase().endsWith('.docx') ? filename : `${filename}.docx`;
        a.download = finalName;
        document.body.appendChild(a);
        a.click();

        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error("DOCX Generation Error:", error);
        alert("Gagal membuat DOCX: " + error.message);
    }
};
